'use client'

import { createContext, useContext } from 'react'

import type { CoinOverall } from '@/types/coin'

import useSubscribeLiveCoinMarket from '../_hooks/useSubscribeLiveCoinMarket'

export interface CoinContextValues {
  coin: CoinOverall
}

export const CoinContext = createContext<CoinContextValues>({} as CoinContextValues)

export const CoinProvider = ({
  children,
  coin,
}: {
  children: React.ReactNode
  coin: CoinOverall
}) => {
  useSubscribeLiveCoinMarket(coin.slug, coin.isPriceAlive)

  return <CoinContext.Provider value={{ coin }}>{children}</CoinContext.Provider>
}

export const useCoinContext = () => {
  return useContext(CoinContext)
}
